import {  Card, CardContent, Grid,Typography } from "@mui/material";

import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import routes from "routes";
import Footer from "pages/LandingPages/Author/sections/Footer";
import MKBox from "components/MKBox";
import bgImage from "../../assets/images/city-profile.jpg"


export default function UserProfile() {

    

    return (
        <div style={{width:"100%"}}>
            <DefaultNavbar
                routes={routes}
                action={{
                    type: "external",
                    route: "https://www.creative-tim.com/product/material-kit-react",
                    label: "free download",
                    color: "info",
                }}
                transparent
                light
            />
            <MKBox
                minHeight="10rem"
                width="100%"
                sx={{
                    backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
                        `${linearGradient(
                            rgba(gradients.dark.main, 0.8),
                            rgba(gradients.dark.state, 0.8)
                        )}, url(${bgImage})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    display: "grid",
                    placeItems: "center",
                }}
            />



            <Typography sx={{ mt: 3 }} textAlign={"center"} variant="h4" >
                User Profile
            </Typography>
            

            <Grid container sx={{ mb: 5, mt: 1 }} justifyContent={"center"} spacing={3}>
                
                <Grid item md={8} xs={10}>
                    <Card>
                        <CardContent sx={{justifyContent:"center"}} spacing={2}>
                            <Grid container direction={"column"} spacing={2}>
                                <Grid item ><Typography textAlign={"center"} variant="h5" gutterBottom> <Typography variant="h5" sx={{color:"#A6CE39"}}>RSA Pin: </Typography> {sessionStorage?.getItem("pin")}</Typography></Grid>
                                <Grid item ><Typography textAlign={"center"} variant="h5" gutterBottom> <Typography variant="h5" sx={{color:"#A6CE39"}}>Firstname: </Typography> {sessionStorage?.getItem("firstName")}</Typography></Grid>
                                <Grid item ><Typography textAlign={"center"} variant="h5" gutterBottom><Typography variant="h5" sx={{color:"#A6CE39"}}>Surname: </Typography> {sessionStorage?.getItem("surname")}</Typography></Grid>
                                <Grid item ><Typography textAlign={"center"} variant="h5" gutterBottom> <Typography variant="h5" sx={{color:"#A6CE39"}}>Other Names: </Typography> {sessionStorage?.getItem("otherNames")}</Typography></Grid>
                                <Grid item ><Typography textAlign={"center"} variant="h5" gutterBottom> <Typography variant="h5" sx={{color:"#A6CE39"}}>Email: </Typography> {sessionStorage?.getItem("email")}</Typography></Grid>
                                <Grid item ><Typography textAlign={"center"} variant="h5" gutterBottom> <Typography variant="h5" sx={{color:"#A6CE39"}}>Employer: </Typography> {sessionStorage?.getItem("employer")}</Typography></Grid>
                                <Grid item ><Typography textAlign={"center"} variant="h5" gutterBottom> <Typography variant="h5" sx={{color:"#A6CE39"}}>Fund Type: </Typography> {sessionStorage?.getItem("fundType")}</Typography></Grid>
                                <Grid item ><Typography textAlign={"center"} variant="h5" gutterBottom> <Typography variant="h5" sx={{color:"#A6CE39"}}> Phone Number: </Typography>{sessionStorage?.getItem("phoneNumber")}</Typography></Grid>
                                <Grid item ><Typography textAlign={"center"} variant="h5" gutterBottom> <Typography variant="h5" sx={{color:"#A6CE39"}}> Account Officer: </Typography>{sessionStorage?.getItem("agentName")}</Typography></Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </Grid>

            </Grid>



            {
}
            


            <Footer />
        </div>
    );
}